import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import '@240tutoring/labs-ui/labs-nav.css';
import './styles.css';
import { reloadOnStaleAssets } from '../../../shared/stale-assets';

// After a deploy an open tab may ask for a lazily loaded file that is gone.
reloadOnStaleAssets();
createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
